module.exports = __webpack_public_path__ + "img/21_76.7d5465e3.png";